import React from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import { DropdownDivider, DropdownItem } from '../../styles/navigation/NavbarStyles';

function DropdownSignOutItem({ onSignOut }) {
  return (
    <>
      <DropdownDivider aria-hidden />
      <DropdownItem onClick={onSignOut} role="menuitem">
        <span className="dropdown-icon" aria-hidden>
          <LogoutIcon sx={{ width: 18, height: 18, color: 'inherit' }} />
        </span>
        Log out
      </DropdownItem>
    </>
  );
}

export default DropdownSignOutItem;
